export default class ClickHelper {

    // Used for calculating clicks on pseudo elements (::before, ::after)
    static getClickOffset(event) {
        return {
            x: this._getClickOffsetX(event),
            y: this._getClickOffsetY(event)
        }
    }

    // ToDo: merge these two functions, as they do basically the same
    static _getClickOffsetX(event) {
        var offsetX = 0;

        if( event.originalEvent instanceof MouseEvent ) {
            offsetX = event.offsetX;
        } else if ( event.originalEvent instanceof TouchEvent ) {
            var rect = event.target.getBoundingClientRect();
            offsetX = event.originalEvent.targetTouches[0].pageX - rect.left;
        }

        return offsetX;
    }

    static _getClickOffsetY(event) {
        var offsetY = 0;

        if( event.originalEvent instanceof MouseEvent ) {
            offsetY = event.offsetY;
        } else if ( event.originalEvent instanceof TouchEvent ) {
            var rect = event.target.getBoundingClientRect();
            offsetY = event.originalEvent.targetTouches[0].pageY - rect.top;
        }

        return offsetY;
    }
}